<p-steps *ngIf="wizard.steps.length > 1" [model]="wizard.steps" [(activeIndex)]="wizard.currentStep"></p-steps>
<ng-container [ngSwitch]="wizard.steps[wizard.currentStep].automationId">
  <div *ngSwitchCase="VerifiedCredentialStepsEnum.ValueProposition" [@enterTrigger]="'switchFade'">
    <div [innerHTML]="wizard.issuer?.valuePropositionHtml | safeHTML" (click)="onContentClick($event)"></div>
  </div>

  <div *ngSwitchCase="VerifiedCredentialStepsEnum.ApplicationHelp" [@enterTrigger]="'switchFade'">
    <div [innerHTML]="wizard.issuer?.helpHtml | safeHTML" (click)="onContentClick($event)"></div>

    <div class="flex flex-column gap-md align-items-center">
      <span translate>verified-credential-wizard.steps.application-help.download-info</span>
      <div class="flex gap-md justify-content-center">
        <button
          *ngIf="wizard.issuer?.iosAppUrl"
          type="button"
          pButton
          [label]="'app.app-store' | translate"
          icon="fab fa-fw fa-apple"
          class="p-button-secondary"
          (click)="onOpenAppLink(wizard.issuer.iosAppUrl)"
        ></button>
        <button
          *ngIf="wizard.issuer?.androidAppUrl"
          type="button"
          pButton
          [label]="'app.play-store' | translate"
          icon="fab fa-fw fa-android"
          class="p-button-secondary"
          (click)="onOpenAppLink(wizard.issuer.androidAppUrl)"
        ></button>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="VerifiedCredentialStepsEnum.TermsOfService" [@enterTrigger]="'switchFade'">
    <vnm-terms-of-service-agreements
      [agreeable]="certification.verifiedCredentialIssuer"
      (canDeactivate)="onActivationChange($event)"
    ></vnm-terms-of-service-agreements>
  </div>

  <div *ngSwitchCase="VerifiedCredentialStepsEnum.PresentationHelp" [@enterTrigger]="'switchFade'">
    <div [innerHTML]="wizard.issuer?.requiredPresentationHelpHtml | safeHTML" (click)="onContentClick($event)"></div>
  </div>
  <div
    *ngSwitchCase="VerifiedCredentialStepsEnum.PersonCredential"
    [@enterTrigger]="'switchFade'"
    class="flex flex-column gap-md"
  >
    <div [innerHTML]="wizard.issuer?.personHtml | safeHTML" (click)="onContentClick($event)"></div>
    <vnm-verified-person
      [issuer]="wizard.issuer"
      [certification]="certification"
      (canDeactivate)="onActivationChange($event)"
    ></vnm-verified-person>
  </div>
  <div
    *ngSwitchCase="VerifiedCredentialStepsEnum.CourseCredential"
    [@enterTrigger]="'switchFade'"
    class="flex flex-column gap-md"
  >
    <div [innerHTML]="wizard.issuer?.courseHtml | safeHTML" (click)="onContentClick($event)"></div>
    <vnm-verified-credential
      [certification]="certification"
      (canDeactivate)="onActivationChange($event)"
    ></vnm-verified-credential>
  </div>
  <div *ngSwitchCase="VerifiedCredentialStepsEnum.IssuerError" [@enterTrigger]="'switchFade'">
    <div class="flex flex-column gap-md">
      <ng-container
        [ngTemplateOutlet]="errorTmpl"
        [ngTemplateOutletContext]="{
          $implicit: certification.verifiedCredentialStatus,
          titleKey: 'verifiable-credentials.issuer-error'
        }"
      ></ng-container>
    </div>
  </div>
  <div *ngSwitchCase="VerifiedCredentialStepsEnum.PlatformError" [@enterTrigger]="'switchFade'">
    <div class="flex flex-column gap-md">
      <ng-container
        [ngTemplateOutlet]="errorTmpl"
        [ngTemplateOutletContext]="{
          $implicit: certification.verifiedCredentialStatus,
          titleKey: 'verifiable-credentials.platform-error'
        }"
      >
      </ng-container>
      <vnm-user-update [certification]="certification" [updateAttrs]="wizard.userAttributes"></vnm-user-update>
    </div>
  </div>
</ng-container>
<div class="flex gap-md justify-content-between">
  <!-- Bindings don't seem to trigger if we just put the buttons here, so we outlet-->
  <ng-container [ngTemplateOutlet]="footerNav"></ng-container>
</div>
<ng-template #footerNav>
  <button
    type="button"
    pButton
    [label]="'app.previous' | translate"
    (click)="prevStep()"
    iconPos="left"
    icon="fa fa-fw fa-angle-left"
    class="mr-auto"
    [attr.hidden]="wizard.currentStep === 0"
  ></button>
  <button
    type="button"
    pButton
    [label]="'app.close' | translate"
    (click)="onDismiss()"
    icon="fa fa-fw fa-times"
    class="p-button-outlined ml-auto"
    [ngClass]="{ 'mr-auto': wizard.steps.length === 1 }"
    [attr.hidden]="wizard.currentStep !== wizard.steps.length - 1 && wizard.steps.length !== 1"
  ></button>
  <button
    type="button"
    pButton
    [label]="'app.next' | translate"
    (click)="nextStep()"
    iconPos="right"
    icon="fa fa-fw fa-angle-right"
    class="ml-auto"
    [disabled]="wizard.running"
    [attr.hidden]="wizard.currentStep === wizard.steps.length - 1"
  ></button>
</ng-template>

<ng-template #errorTmpl let-status let-title="titleKey">
  <span [innerHTML]="title | translate"></span>
  <fieldset>
    <legend [translateParams]="{ error: status }" translate>verifiable-credentials.legend-error</legend>
    <div class="flex gap-md align-items-center">
      <fa-icon icon="exclamation-triangle" size="2x"></fa-icon>
      <span translate>verifiable-credentials.credential-status.{{ status }}</span>
    </div>
  </fieldset>
</ng-template>
